export { default as iconMapper } from './IconMapper';
